import {Space} from 'antd';

import {Text} from '../../../../../component/text/text';
import {useDomainConfig} from '../../../../../provider/domain-config/domain-config-hook';
import {ShortLocaleNameEnum} from '../../../../../provider/locale/locale-context-type';
import {Locale} from '../../../../../provider/locale/localization';
import {useUser} from '../../../../../provider/user/user-hook';
import {classNames} from '../../../../../util/css';

import {authenticatorLinks} from './two-factor-description-const';
import * as styles from './two-factor-description.scss';

type PropsType = {
    className?: string;
    inlineForm?: JSX.Element;
};

export function TwoFactorDescription(props: PropsType): JSX.Element {
    const {className, inlineForm} = props;
    const {isShowOtherTwoFactorProduct} = useDomainConfig();
    const {user} = useUser();

    const isShowOtherTwoFactor = isShowOtherTwoFactorProduct && user?.language === ShortLocaleNameEnum.ru;

    return (
        <div className={classNames(styles.TwoFactorDescription, className)}>
            <Text
                block
                bolder
                stringKey="PROFILE__TWO_FACTOR_AUTHENTICATION__HOW_TO_SET_UP_GOOGLE_AUTHENTICATOR"
                valueMap={{
                    otherProduct: isShowOtherTwoFactor ? (
                        <Locale stringKey="PROFILE__TWO_FACTOR_AUTHENTICATION__OTHER_PRODUCT" />
                    ) : (
                        ''
                    ),
                }}
            />

            <ol>
                <li>
                    <Text
                        block
                        stringKey="PROFILE__TWO_FACTOR_AUTHENTICATION__SET_UP_STEP__1"
                        valueMap={{
                            otherProduct: isShowOtherTwoFactor ? (
                                <Locale stringKey="PROFILE__TWO_FACTOR_AUTHENTICATION__OTHER_PRODUCT" />
                            ) : (
                                ''
                            ),
                        }}
                    />

                    <Space wrap>
                        {Object.entries(authenticatorLinks)
                            .filter((link) => !link[0].includes('Яндекс') || isShowOtherTwoFactor)
                            .map(([store, link]) => (
                                <a href={link} key={store} rel="noreferrer" target="_blank">
                                    {store}
                                </a>
                            ))}
                    </Space>
                </li>

                <li>
                    <Text block stringKey="PROFILE__TWO_FACTOR_AUTHENTICATION__SET_UP_STEP__2" />

                    <Text block secondary stringKey="PROFILE__TWO_FACTOR_AUTHENTICATION__SET_UP_STEP__2_DESCRIPTION" />
                </li>

                <li>
                    <Locale stringKey="PROFILE__TWO_FACTOR_AUTHENTICATION__SET_UP_STEP__3" />

                    {inlineForm}
                </li>
            </ol>
        </div>
    );
}
